import qs from "qs";
import product from "src/common/config/product";
import get from "lodash/get";
import { localiseUrlII } from "src/common/utils/format-localised-url";
import logger from "src/logger";

const buildProductUrl = (props, options) => {
  const eagleProduct =
    props.model.eagleProduct ||
    props.model.eagleModel?.products?.find(({ id }) => id === props.productId);

  if (eagleProduct || product.getProductBySku(props.productId)) {
    const productSlug = eagleProduct
      ? eagleProduct.slug
      : product.getProductBySku(props.productId).slug;

    const countryModel = props.model.countryModel;

    if (!productSlug) {
      logger.error(
        "Failed to redirect user to canvas page as slug was missing"
      );
      // As this method is used as a href in a link or directly setting the window location
      // we are just going to return the current window location to stop the user from
      // navigating anywhere
      return window.location;
    }

    const browserQuery = get(props, "history.location.search", "");

    let url = `/personalized-products/${productSlug}`;
    let search = qs.stringify(
      {
        ...qs.parse(browserQuery, { ignoreQueryPrefix: true }),
        ...props.queryParams,
        ...options.queryParams,
      },
      { addQueryPrefix: true }
    );

    switch (options.type) {
      case "cart":
        url = "/cart";
        search = "";
        break;
      default:
        url += `/${options.type}`;
        if (options.itemId) {
          url += `/${options.itemId}`;
        }
        break;
    }

    return localiseUrlII(countryModel, `/${url}${search}`);
  }

  // We get here if we don't have a eagle product slug or a product in our config.  Currently
  // this situation is for new addons as line items project.
  //
  // As this method is used as a href in a link or directly setting the window location
  // we are just going to return the current window location to stop the user from
  // navigating anywhere - as above.
  return window.location;
};

export default buildProductUrl;
